import Divider from '@mui/material/Divider';
import { FaMapMarkerAlt, FaPhone, FaClock } from 'react-icons/fa';
import { useTranslation } from 'react-i18next';
import Developed from './Developed';

const today = new Date();

const Footer = () => {
  const { t } = useTranslation();

  return (
    <footer className="mt-10 mx-auto max-w-[1200px] lg:px-0 px-8">
      <div className="lg:flex">
        {/* Visit Us */}
        <section className="lg:w-4/12">
          <div className="flex items-center gap-2 text-[#DC143C] font-bold text-2xl mb-4">
            <FaMapMarkerAlt />
            {t('footer.visitUs')}
          </div>
          <div className="my-2">
            <Divider />
          </div>
          <address className="not-italic leading-relaxed">
            <div className="font-bold">Felfela Kraków</div>
            
          </address>
        </section>

        {/* Contact Us */}
        <section className="lg:w-4/12 mt-8 lg:mt-0">
          <div className="flex items-center gap-2 text-[#DC143C] font-bold text-2xl mb-4">
            <FaPhone />
            {t('footer.contactUs')}
          </div>
          <div className="my-2">
            <Divider />
          </div>
          <div>
            <a
              href="tel:663812867"
              className="hover:text-[#DC143C] transition-colors"
            >
              663 812 867
            </a>
          </div>
        </section>

        {/* Opening Hours */}
        <section className="lg:w-4/12 mt-8 lg:mt-0">
          <div className="flex items-center gap-2 text-[#DC143C] font-bold text-2xl mb-4">
            <FaClock />
            {t('footer.openingHours')}
          </div>
          <div className="my-2">
            <Divider />
          </div>
          <ul className="space-y-2">
            <li className="flex flex-col lg:flex-row lg:justify-between">
              <span>{t('footer.mondayFriday')}</span>
              <span>{t('footer.mondayFridayHours')}</span>
            </li>
            <li className="flex flex-col lg:flex-row lg:justify-between">
              <span>{t('footer.saturdaySunday')}</span>
              <span>{t('footer.weekendHours')}</span>
            </li>
          </ul>
        </section>
      </div>

      <div className="my-6">
        <Divider />
      </div>

      <div className="py-2">
        <span>&copy;</span> {today.getFullYear()} Felfela Kraków 
      </div>

      <div>
        <Developed />
      </div>
    </footer>
  );
};

export default Footer;